export const TIMEOUT = 10000; // after 10 seconds, go back to the hone screen
export const SYNC_FREQUENCY = 60000; // push data to the cloud every minute
export const CLEAR_LOCAL_DB_FREQUENCY = 60000*60; // clear local db every 60 minutes
export const ANIMATION_FREQUENCY = 500; // 0.5 second
export const BANNER_STAY_TIME = 3000; // 3 seconds
export const FACES_RANDOM_ANIMATION_FREQUENCY = 1000; // 1 second
export const COMPLAINT_SUBMIT_TIMEOUT = 1000; // 1 second to submit complaint